import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solutions-title',
  templateUrl: './solutions-title.component.html',
  styleUrls: ['./solutions-title.component.css']
})
export class SolutionsTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
